import {
  Directive,
  Input,
  OnChanges, OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef, ViewRef
} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';

@Directive({
  selector: '[isAnyGranted]',
  standalone: true
})
export class IsAnyGrantedDirective implements OnInit, OnChanges {

  @Input() isAnyGranted: string[] = [];

  private visible = false;
  private embeddedViewRef: ViewRef | null = null;

  constructor(
    private auth: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
  }

  ngOnInit(): void {
    this.updateElement();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.auth.hasAnyRoles(changes['isAnyGranted'].currentValue).subscribe((isAnyGranted: boolean) => {
      this.visible = isAnyGranted;
      this.updateElement();
    });
  }

  private updateElement(): void {
    if (this.visible) {
      if (this.embeddedViewRef === null) {
        this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      if (this.embeddedViewRef) {
        this.viewContainer.clear();
        this.embeddedViewRef = null;
      }
    }
  }
}
